import React, {FunctionComponent} from 'react';

interface ValidationErrorTextProps {
    text: string
}

export const ValidationErrorText: FunctionComponent<ValidationErrorTextProps> = (props) => {
    return (
        <span className='validation-error-text'>{props.text}</span>
    );
}